import React, {useEffect} from 'react';
import Button from '@mui/material/Button';
import { useState } from 'react'
import { useDispatch } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { postRegister, acceptInvite, getInviteByToken } from '../../Redux/actions';
import AlertDialog from '../Common/AlertDialog';
import { Link, useNavigate, useParams } from "react-router-dom";
import GreenvironmentLogo from '../../../src/Images/GreenvironmentLogo.svg'
import { CircularProgress } from '@mui/material';
import AuthHero from './AuthHero';
import { authGradientButtonSx } from '../../theme/formStyles';
import './Login.css';

export default function SignUp({invite=false}) {
  const { token } = useParams();

  const dispatch = useDispatch();
    const initForm = {
        uniqueId: '',
        password: '',
        confirm: ''
    };

    let navigate = useNavigate();
    const initErr = {};
    const [form, setForm] = useState(initForm);
    const [errors, setErrors] = useState(initErr);
    const [alertMessage, setAlertMessage] = useState();
    const [passReg, setPassReg] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

    useEffect(() => {
      dispatch(getInviteByToken(token)).then((res) => {
          const response = res?.data;
          if (!response) {
              return
          }
          const flowData = {
            name: response.name,
            uniqueId: response.emailId
          }
          setForm(flowData);
      })
  }, [token])

    const handleChange = (e) => {
      const { value, name } = e.target;
      const fieldValue = Object.assign({}, form);
      const errorField = Object.assign({}, errors);
      if (errorField[name]) {
          errorField[name] = null;
          setErrors(errorField);
      }
      fieldValue[name] = value;
      if (name === 'uniqueId') {
          fieldValue[name] = value.toLowerCase();
      }
      setPassReg(false);
      setForm(fieldValue);
  };

  const emailValidator = (email) =>{
    const pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
    return pattern.test(email);
  }

  const passwordValidator = (password)=>{
    const pattern = new RegExp(/^(?=.*[a-z]+)(?=.*[A-Z]+)(?=.*[0-9]+)(?=.*[!@#$%^&*]).{8,20}$/);
    return pattern.test(password);
}

  const validateData = () => {
    let hasError = false;
    const err = Object.assign({}, errors);

    if (!form.name) {
      hasError = true;
      err.name = 'This field is mandatory.';
  }
    if (!emailValidator(form.uniqueId)) {
        hasError = true;
        err.uniqueId = 'Enter a valid email.';
    }
    if (form.password !== form.confirm) {
        hasError = true;
        err.confirm = 'New Password and confirm password must be same.';
    }

    if (!passwordValidator(form.password)) {
        hasError = true;
        setPassReg(true);
        err.password = `Password doesn't meet the requirements`;
    }

    Object.keys(form).forEach((key) => {
        if (typeof (form[key]) === 'string' && key !== 'password' && key !== 'confirm') {
            if (!form[key].match(/\w/)) {
                hasError = true;
                err[key] = 'This field is mandatory';
            }
        }
        if (!form[key]) {
            hasError = true;
            err[key] = 'This field is mandatory';
        }
    });
    if (hasError) {
        setErrors(err);
        return false;
    }
    return form;
};
if(token && !form.name) {
  return (
    <div className="gv-login-page">
      <AuthHero />
      <div className="gv-login-panel">
        <div className="gv-login-card" style={{ display: 'flex', justifyContent: 'center', padding: '60px 30px' }}>
          <CircularProgress sx={{ color: '#008080' }} />
        </div>
      </div>
    </div>
  );
}

  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = validateData();
    if (valid) {
      if(token && invite) {
        valid.token = token
        dispatch(acceptInvite(valid)).then((resp) => {
          const res = resp && resp.data;
            if (res && res.success) {
                setAlertMessage('Registered successfully...!');
            } else if (res && !res.success) {
                setAlertMessage('User Already Exists, Please Login...!');
            } else if (res && res.data) {
                setErrors(res.data);
            } else {
                setAlertMessage('Something went wrong. Try again...!');
            }
        })
      } else {
        dispatch(postRegister(valid)).then((resp) => {
            const res = resp && resp.data;
            if (res && res.success) {
                setAlertMessage('Registered successfully...!');
            } else if (res && !res.success) {
                setAlertMessage('User Already Exists, Please Login...!');
            } else if (res && res.data) {
                setErrors(res.data);
            } else {
                setAlertMessage('Something went wrong. Try again...!');
            }
        });
      }
    }
};

  return (
    <div className="gv-login-page">
      <AuthHero />

      <div className="gv-login-panel">
        <div className="gv-login-card">
          <div className="gv-login-card-logo">
            <img alt="Greenvironment" src={GreenvironmentLogo} />
          </div>
          <div className="gv-login-heading">Create your account</div>
          <div className="gv-login-subheading">Sign up to access your AI Dashboard</div>

          <form noValidate onSubmit={handleSubmit}>
            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="name">Full Name</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><PersonIcon fontSize="small" /></span>
              <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={form.name || ''}
                  disabled={!!token}
                  onChange={handleChange}
                  className="gv-login-input"
                />
            </div>
            {errors.name && <div className="gv-login-error">{errors.name}</div>}

            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="uniqueId">Email</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><EmailIcon fontSize="small" /></span>
              <input
                id="uniqueId"
                name="uniqueId"
                placeholder="Enter your email"
                disabled={!!token}
                value={form.uniqueId}
                onChange={handleChange}
                className="gv-login-input"
              />
            </div>
            {errors.uniqueId && <div className="gv-login-error">{errors.uniqueId}</div>}

            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="password">Password</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><LockOutlinedIcon fontSize="small" /></span>
              <input
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  value={form.password}
                  onChange={handleChange}
                  className="gv-login-input"
                  style={{ paddingRight: 40 }}
                  type={showPassword ? 'text' : 'password'}
              />
               <IconButton size="small" className="gv-login-pw-toggle" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                </IconButton>
            </div>
            {errors.password && <div className="gv-login-error">{errors.password}</div>}
              {
                passReg === true &&
                <ul className="gv-login-pw-rules">
                  <li>Minimum password length 8</li>
                  <li>Maximum password length 20</li>
                  <li>Required at least one digit</li>
                  <li>Required at least one upper case</li>
                  <li>Required at least one lower case</li>
                  <li>Required at least one symbol</li>
                </ul>
              }

            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="confirm">Confirm Password</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><LockOutlinedIcon fontSize="small" /></span>
              <input
                  id="confirm"
                  name="confirm"
                  placeholder="Confirm password"
                  value={form.confirm}
                  onChange={handleChange}
                  className="gv-login-input"
                  style={{ paddingRight: 40 }}
                  type={showPasswordConfirm ? 'text' : 'password'}
              />
               <IconButton size="small" className="gv-login-pw-toggle" onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}>
                  {showPasswordConfirm ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                </IconButton>
            </div>
            {errors.confirm && <div className="gv-login-error">{errors.confirm}</div>}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={authGradientButtonSx}
            >
              Sign Up
            </Button>
          </form>

          <div className="gv-login-footer-link">
            Already have an account? <Link className="gv-login-forgot-link" to="/login">Login</Link>
          </div>
        </div>
      </div>

      {alertMessage
    ? (
        <AlertDialog
            handleClose={() => {
                setAlertMessage(null);
                navigate('/login');
            }}
            message={alertMessage}
        />
    ) : null}
    </div>
  );
}
